/**
 * @generated SignedSource<<c0b665162658b9b19859679b8ae84b9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BankTransactionGroup = "CUSTOMER_PAYMENTS" | "FINANCING" | "OTHER" | "SALARIES" | "SUPPLIERS" | "TAX_OFFICE" | "TRANSFER" | "%future added value";
export type DoubtfulReceivableReason = "LONG_OVERDUE" | "SLOW_PAYER" | "%future added value";
export type ForecastCategory = "DEPRECIATION" | "FINANCING" | "INCOME_TAXES" | "OTHER" | "OTHER_OPERATING_INCOME" | "PERSONNEL" | "REVENUE" | "SUPPLIERS" | "%future added value";
export type ForecastLiquidityStatus = "BANK" | "BANK_AND_FORECAST" | "FORECAST" | "%future added value";
export type ForecastMonthStatus = "CLOSED" | "FORECAST" | "PROVISIONAL" | "%future added value";
export type AnalysisForecastOverviewViewQuery$variables = Record<PropertyKey, never>;
export type AnalysisForecastOverviewViewQuery$data = {
  readonly forecast: {
    readonly balanceAtLastBookingDay: number;
    readonly bankAccounts: ReadonlyArray<{
      readonly bankAccountIdentifier: string;
      readonly bankAccountName: string;
      readonly coveredUntil: any | null | undefined;
    }>;
    readonly coverageDiffers: boolean;
    readonly currentMonth: string;
    readonly doubtfulReceivables: ReadonlyArray<{
      readonly customerName: string;
      readonly daysOverdue: number;
      readonly grossAmount: number;
      readonly invoiceIdentifier: string;
      readonly invoiceNumber: string | null | undefined;
      readonly reason: DoubtfulReceivableReason;
    }>;
    readonly lastBookingDay: any;
    readonly minimumBalance: {
      readonly amount: number;
    } | null | undefined;
    readonly months: ReadonlyArray<{
      readonly liquidity: {
        readonly accountBalances: ReadonlyArray<{
          readonly bankAccountIdentifier: string;
          readonly bankAccountName: string;
          readonly closingBalance: number;
        }>;
        readonly closingBalance: number;
        readonly hasForecastDays: boolean;
        readonly inflows: ReadonlyArray<{
          readonly amount: number;
          readonly isOverdueReceivables: boolean;
          readonly parts: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"AnalysisForecastPartsPanel_part">;
          }>;
          readonly transactionGroup: BankTransactionGroup;
        }>;
        readonly lowestBalance: number;
        readonly lowestBalanceDay: any;
        readonly openingBalance: number;
        readonly outflows: ReadonlyArray<{
          readonly amount: number;
          readonly isOverdueReceivables: boolean;
          readonly parts: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"AnalysisForecastPartsPanel_part">;
          }>;
          readonly transactionGroup: BankTransactionGroup;
        }>;
        readonly status: ForecastLiquidityStatus;
        readonly totalInflows: number;
        readonly totalOutflows: number;
        readonly transferNet: number;
      };
      readonly month: string;
      readonly result: {
        readonly bwaComparisonLines: ReadonlyArray<{
          readonly amount: number;
          readonly category: ForecastCategory;
          readonly parts: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"AnalysisForecastPartsPanel_part">;
          }>;
        }>;
        readonly expenses: number;
        readonly income: number;
        readonly lines: ReadonlyArray<{
          readonly amount: number;
          readonly category: ForecastCategory;
          readonly parts: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"AnalysisForecastPartsPanel_part">;
          }>;
        }>;
        readonly result: number;
        readonly resultBeforeIncomeTaxes: number;
      };
      readonly status: ForecastMonthStatus;
    }>;
    readonly shortfallDay: any | null | undefined;
  };
};
export type AnalysisForecastOverviewViewQuery = {
  response: AnalysisForecastOverviewViewQuery$data;
  variables: AnalysisForecastOverviewViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentMonth",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastBookingDay",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverageDiffers",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bankAccountIdentifier",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bankAccountName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ForecastBankAccount",
  "kind": "LinkedField",
  "name": "bankAccounts",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coveredUntil",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balanceAtLastBookingDay",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortfallDay",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "MinimumBalance",
  "kind": "LinkedField",
  "name": "minimumBalance",
  "plural": false,
  "selections": [
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "income",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expenses",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resultBeforeIncomeTaxes",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceIdentifier",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vatAmount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grossAmount",
  "storageKey": null
},
v23 = [
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bwaField",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "expenseCategory",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isPostponedToNextMonth",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "SupplierAmountEstimate",
    "kind": "LinkedField",
    "name": "supplierAmountEstimate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "source",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "origin",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "estimatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "netAmount",
    "storageKey": null
  },
  (v21/*: any*/),
  (v22/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ForecastVatPayable",
    "kind": "LinkedField",
    "name": "vatPayable",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paymentDate",
        "storageKey": null
      },
      (v8/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ForecastVatComponent",
        "kind": "LinkedField",
        "name": "components",
        "plural": true,
        "selections": [
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ForecastPart",
  "kind": "LinkedField",
  "name": "parts",
  "plural": true,
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "AnalysisForecastPartsPanel_part",
      "selections": (v23/*: any*/),
      "args": null,
      "argumentDefinitions": ([]/*: any*/)
    }
  ],
  "storageKey": null
},
v25 = [
  (v16/*: any*/),
  (v8/*: any*/),
  (v24/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openingBalance",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalInflows",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalOutflows",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transferNet",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closingBalance",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lowestBalance",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lowestBalanceDay",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasForecastDays",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transactionGroup",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOverdueReceivables",
  "storageKey": null
},
v36 = [
  (v34/*: any*/),
  (v35/*: any*/),
  (v8/*: any*/),
  (v24/*: any*/)
],
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "ForecastAccountBalance",
  "kind": "LinkedField",
  "name": "accountBalances",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v30/*: any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "DoubtfulReceivable",
  "kind": "LinkedField",
  "name": "doubtfulReceivables",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiceIdentifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiceNumber",
      "storageKey": null
    },
    (v22/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "daysOverdue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "ForecastPart",
  "kind": "LinkedField",
  "name": "parts",
  "plural": true,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v40 = [
  (v16/*: any*/),
  (v8/*: any*/),
  (v39/*: any*/)
],
v41 = [
  (v34/*: any*/),
  (v35/*: any*/),
  (v8/*: any*/),
  (v39/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisForecastOverviewViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Forecast",
        "kind": "LinkedField",
        "name": "forecast",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ForecastMonth",
            "kind": "LinkedField",
            "name": "months",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ForecastMonthResult",
                "kind": "LinkedField",
                "name": "result",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForecastResultLine",
                    "kind": "LinkedField",
                    "name": "lines",
                    "plural": true,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForecastResultLine",
                    "kind": "LinkedField",
                    "name": "bwaComparisonLines",
                    "plural": true,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ForecastMonthLiquidity",
                "kind": "LinkedField",
                "name": "liquidity",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForecastLiquidityLine",
                    "kind": "LinkedField",
                    "name": "inflows",
                    "plural": true,
                    "selections": (v36/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForecastLiquidityLine",
                    "kind": "LinkedField",
                    "name": "outflows",
                    "plural": true,
                    "selections": (v36/*: any*/),
                    "storageKey": null
                  },
                  (v37/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v38/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AnalysisForecastOverviewViewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Forecast",
        "kind": "LinkedField",
        "name": "forecast",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ForecastMonth",
            "kind": "LinkedField",
            "name": "months",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ForecastMonthResult",
                "kind": "LinkedField",
                "name": "result",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForecastResultLine",
                    "kind": "LinkedField",
                    "name": "lines",
                    "plural": true,
                    "selections": (v40/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForecastResultLine",
                    "kind": "LinkedField",
                    "name": "bwaComparisonLines",
                    "plural": true,
                    "selections": (v40/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ForecastMonthLiquidity",
                "kind": "LinkedField",
                "name": "liquidity",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForecastLiquidityLine",
                    "kind": "LinkedField",
                    "name": "inflows",
                    "plural": true,
                    "selections": (v41/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForecastLiquidityLine",
                    "kind": "LinkedField",
                    "name": "outflows",
                    "plural": true,
                    "selections": (v41/*: any*/),
                    "storageKey": null
                  },
                  (v37/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v38/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a4740436e2d32d211ebb76b0730ac256",
    "id": null,
    "metadata": {},
    "name": "AnalysisForecastOverviewViewQuery",
    "operationKind": "query",
    "text": "query AnalysisForecastOverviewViewQuery {\n  forecast {\n    currentMonth\n    lastBookingDay\n    coverageDiffers\n    bankAccounts {\n      bankAccountIdentifier\n      bankAccountName\n      coveredUntil\n    }\n    balanceAtLastBookingDay\n    shortfallDay\n    minimumBalance {\n      amount\n    }\n    months {\n      month\n      status\n      result {\n        income\n        expenses\n        resultBeforeIncomeTaxes\n        result\n        lines {\n          category\n          amount\n          parts {\n            ...AnalysisForecastPartsPanel_part\n          }\n        }\n        bwaComparisonLines {\n          category\n          amount\n          parts {\n            ...AnalysisForecastPartsPanel_part\n          }\n        }\n      }\n      liquidity {\n        status\n        openingBalance\n        totalInflows\n        totalOutflows\n        transferNet\n        closingBalance\n        lowestBalance\n        lowestBalanceDay\n        hasForecastDays\n        inflows {\n          transactionGroup\n          isOverdueReceivables\n          amount\n          parts {\n            ...AnalysisForecastPartsPanel_part\n          }\n        }\n        outflows {\n          transactionGroup\n          isOverdueReceivables\n          amount\n          parts {\n            ...AnalysisForecastPartsPanel_part\n          }\n        }\n        accountBalances {\n          bankAccountIdentifier\n          bankAccountName\n          closingBalance\n        }\n      }\n    }\n    doubtfulReceivables {\n      invoiceIdentifier\n      customerName\n      invoiceNumber\n      grossAmount\n      daysOverdue\n      reason\n    }\n  }\n}\n\nfragment AnalysisForecastPartsPanel_part on ForecastPart {\n  kind\n  label\n  sourceIdentifier\n  count\n  bwaField\n  expenseCategory\n  isPostponedToNextMonth\n  supplierAmountEstimate {\n    source\n    origin\n    estimatedAt\n  }\n  date\n  netAmount\n  vatAmount\n  grossAmount\n  vatPayable {\n    month\n    paymentDate\n    amount\n    components {\n      kind\n      label\n      sourceIdentifier\n      count\n      vatAmount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b1dc178284018070f06cc4a0ca6027f";

export default node;
